import { render, staticRenderFns } from "./gravid_recap.vue?vue&type=template&id=10eb50da&"
import script from "./gravid_recap.vue?vue&type=script&lang=js&"
export * from "./gravid_recap.vue?vue&type=script&lang=js&"
import style0 from "./gravid_recap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports